"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Nullable = void 0;
const typebox_1 = require("@sinclair/typebox");
// Note: For nullable values like those described by this Nullable helper, the array passed to Type.Union()
// must have Type.Null() as its first item; otherwise, fastify's JSON schema parser, ajv, will set nullable
// numeric values to 0 in requests when they were originally set in their payloads to null.
const Nullable = (schema) => typebox_1.Type.Optional(typebox_1.Type.Union([schema, typebox_1.Type.Null()]));
exports.Nullable = Nullable;
//# sourceMappingURL=nullable.js.map